<template>
  <div
    v-if="frameSpec"
    class="pv-gallery__item-upload--artwork pv-gallery__item-upload"
    >
      <RenderSvgFrame
        :frameSpec="frameSpec"
        class="content"
      />
      <Teleport
        v-if="galleryZoomCell"
        :to="galleryZoomCell"
      >
        <div class="pv-gallery__item-upload ">
          <RenderSvgFrame
            :frameSpec="frameSpec"
            class="content __uploaded-shadow"
          />
        </div>
      </Teleport>
  </div>
  <div
    v-else
    class="pv-gallery__item-upload--artwork-loading is-loading"
  ></div>
</template>

<script>
import { onMounted, Teleport } from 'vue';
import RenderSvgFrame from '@framebridge/toolbox/components/RenderSvg/RenderSvgFrame.vue';
import useFrameSpecData from '../composables/frame-spec';

export default {
  name: 'PostArtwork',
  components: {
    RenderSvgFrame,
    Teleport,
  },

  props: {
    handle: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    variantSpec: {
      type: String,
      required: false,
    },
    variantId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const {
      frameSpec,
      checkFrameSpecData,
      getFrameSpecById,
    } = useFrameSpecData(
      {
        handle: props.handle,
        type: props.type,
      },
      null,
      props.variantSpec,
    );
    const galleryModal = document.getElementById(`productGalleryZoomModal${props.variantId}`) || null;
    const galleryZoomCell = galleryModal?.querySelector('.js-post-artwork-zoom') || null;

    onMounted(() => {
      if (props.variantSpec) {
        getFrameSpecById(props.variantSpec);
      } else {
        checkFrameSpecData();
      }
    });

    return {
      frameSpec,
      galleryZoomCell,
    };
  },
};
</script>
